<script setup>
import { computed, ref } from 'vue';
import Multiselect from 'vue-multiselect';
import CheckIcon from '@assets/icons/check.svg';

const { material } = defineProps({
    material: {
        type: Object,
        required: true,
    },
});

const model = defineModel({
    type: Array,
    required: true,
});

const multiselectRef = ref(null);

const options = computed(() => [material, ...material.children]);

const amountOfSelected = computed(
    () =>
        options.value.filter((option) =>
            model.value.map((material) => material.id).includes(option.id),
        ).length,
);
</script>

<template>
    <div class="w-auto multiselect-round">
        <Multiselect
            ref="multiselectRef"
            v-model="model"
            :options="options"
            multiple
            :toggle="true"
            openDirection="bottom"
            :close-on-select="false"
            select-label=""
            placeholder=""
            selected-label=""
            deselect-label=""
            label="title"
            track-by="id"
            :searchable="false"
            :max-height="400"
            :class="{ active: amountOfSelected >= 1 }"
        >
            <template #selection>
                <span
                    class="multiselect__single mr-4"
                    @mousedown.prevent.stop="multiselectRef.toggle()"
                >
                    {{ material.title }} ({{ amountOfSelected }})
                </span>
            </template>

            <template #option="props">
                <div class="flex justify-between items-center">
                    <div>{{props.option.title}}</div>

                    <div v-if="model.some((material) => (material.id === props.option.id))">
                        <CheckIcon class="w-4 h-4" />
                    </div>
                </div>
            </template>
        </Multiselect>
    </div>
</template>
